import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import WhatsAppButton from "@/components/feature/WhatsAppButton";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        {/* Edge gradient vignette overlay — warm cream glow on all sides */}
        <div
          className="fixed inset-0 pointer-events-none z-[9999]"
          style={{
            background: `
              radial-gradient(ellipse at top left, rgba(232, 213, 183, 0.45) 0%, transparent 55%),
              radial-gradient(ellipse at top right, rgba(232, 213, 183, 0.45) 0%, transparent 55%),
              radial-gradient(ellipse at bottom left, rgba(232, 213, 183, 0.45) 0%, transparent 55%),
              radial-gradient(ellipse at bottom right, rgba(232, 213, 183, 0.45) 0%, transparent 55%),
              linear-gradient(to right, rgba(224, 205, 170, 0.35) 0%, transparent 12%, transparent 88%, rgba(224, 205, 170, 0.35) 100%),
              linear-gradient(to bottom, rgba(224, 205, 170, 0.25) 0%, transparent 8%, transparent 92%, rgba(224, 205, 170, 0.25) 100%)
            `,
          }}
        />
        <AppRoutes />
        <WhatsAppButton />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
